export const load = () => {
  try {
    return JSON.parse(localStorage.getItem("app") || "{}");
  } catch (err) {
    console.warn("Failed to load persisted app state:", err);
    return {};
  }
};

export const save = (d) => {
  try {
    localStorage.setItem("app", JSON.stringify(d));
    return true;
  } catch (err) {
    // Base64 image payloads can exceed browser storage quota.
    // Keep app state updates working even if persistence fails.
    console.warn("Failed to persist app state:", err);
    return false;
  }
};
